import _ from 'lodash';
import React, { useState } from 'react';

import { PartialRecord } from '@scale/shared/types/utils';
import useShortcut from 'react-scale/hooks/useShortcut';
import { Modal, ModalHeader } from 'design-system/Modal';
import { IInstructionItemJson } from '@scale/shared/types/instructionitem';

export type InstructionItemSummaryData = PartialRecord<
  string,
  {
    annotations: string[];
    instrItem: IInstructionItemJson;
    count: number;
  }
>;

/**
 *  Make sure to use useMemo if you are
 *  using a function to transform an object into InstructionItemSummaryData.
 */
interface InstructionItemSummaryProps {
  isAnswerKey?: boolean;
  shortcutKey?: string;
  data: InstructionItemSummaryData;
}

const InstructionItemSummary = (props: InstructionItemSummaryProps) => {
  const { data, shortcutKey } = props;

  const [showInstrItemSummary, toggleInstrItemSummary] = useState(false);
  useShortcut({
    trigger: shortcutKey ?? 'w',
    action: () => toggleInstrItemSummary(!showInstrItemSummary),
    description: 'Toggle Instruction Item summary',
  });

  return (
    <Modal
      maxWidth="720px"
      contentLabel="Instruction Item Summary"
      isOpen={showInstrItemSummary}
      onRequestClose={() => toggleInstrItemSummary(!showInstrItemSummary)}
    >
      <ModalHeader onRequestClose={() => toggleInstrItemSummary(!showInstrItemSummary)}>
        <div>Instruction Item Summary</div>
        {props.isAnswerKey !== undefined && (
          <>
            <div
              style={{
                fontSize: '15px',
                fontWeight: 'normal',
                marginTop: '5px',
                marginBottom: '5px',
              }}
            >
              for
            </div>{' '}
            {props.isAnswerKey ? 'Answer Key' : 'Initial Response'}
          </>
        )}
      </ModalHeader>
      {_.map(data, function (value, key) {
        if (!value?.instrItem) {
          return;
        }
        return (
          <div className="instruction-item" key={key}>
            <div className="group">
              <div>
                <div>{value!.instrItem.name}</div>
                <small>{key}</small>
              </div>
              <div>
                <h3>
                  Ids:{' '}
                  {_.join(
                    _.map(value!.annotations, id => (id.length > 20 ? id.slice(-4) : id)),
                    ', ',
                  )}
                </h3>
              </div>
              <div>
                <h3>Count: {value!.count}</h3>
              </div>
              <div style={{ width: '8px' }} />
            </div>
          </div>
        );
      })}
      <style jsx>{`
        .instruction-item {
          margin: 8px 0;
          padding: 8px;
          background: var(--color-RemoGray01);
          border-radius: var(--border-radius);

          font-size: 13px;
        }

        .instruction-item .group {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      `}</style>
    </Modal>
  );
};

export default InstructionItemSummary;
